import Device from 'Faster/model/Device';
import FasterRequest from 'Faster/network/FasterRequest';
import ServerDate from 'Faster/model/ServerDate';

class UpdateDeviceRequest implements FasterRequest {
  public readonly method: string = FasterRequest.METHOD_PUT;
  private localTimestamp: Date;
  private ntpLocalTimestamp: Date;
  private device: Device;

  public constructor(device: Device, localTimestamp: Date) {
    this.localTimestamp = localTimestamp;
    this.ntpLocalTimestamp = ServerDate.now();
    this.device = device;
  }

  public body(): object {
    return {
      deviceId: this.device.id,
      systemVersion: this.device.systemVersion,
      appVersion: this.device.appVersion,
      sdkVersion: this.device.sdkVersion,
      pushToken: this.device.pushToken,
      cloudId: this.device.cloudId,
      carrierId: this.device.carrierId,
      timezone: this.device.timezone,
      language: this.device.language,
      deviceProperties: this.device.properties,
      localTimestamp: this.localTimestamp,
      ntpLocalTimestamp: this.ntpLocalTimestamp,
    };
  }

  public headers(): object {
    return {
      'Content-Type': 'application/json',
    };
  }

  public endpoint = (): string => '/v1/device/' + this.device.id;

  public query = (): string => '';
}

export default UpdateDeviceRequest;
